import { render, staticRenderFns } from "./EmployeeAssignedFormsList.vue?vue&type=template&id=522d63a8&"
import script from "./EmployeeAssignedFormsList.vue?vue&type=script&lang=js&"
export * from "./EmployeeAssignedFormsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports